import { supabase } from './supabase';

// ============================================================================
// Centralized data-access schema helpers.
//
// Estate convention (verified against the live database):
//  - Shared operational tables are fronted by public security-invoker VIEWS
//    (or_cases, case_events/vitals/supplies/medications/equipment, org_members,
//    organizations, or_* inventory, surgeon_preference_cards, dea_*). Those are
//    the approved read surfaces and are reachable via the default client
//    (supabase.from(...)).
//  - Tables with no public view (clinical detail and private records:
//    providers, facilities, operative_note_detailed, surgical_progress_notes,
//    patient_consents, informed_consent_templates, case_evidence_assets, ...)
//    are reached explicitly through cr()/saas(). Row-Level Security gates every
//    path regardless of which is used.
//
// Keeping the schema decision here (rather than sprinkling supabase.schema(...)
// through components) is what "hardens the browser data layer": the coupling to
// internal schemas lives in one auditable place.
// ============================================================================

/** cr.* clinical repository schema (RLS-gated). */
export const cr = () => supabase.schema('cr');

/** saas.* multi-tenant schema (RLS-gated). */
export const saas = () => supabase.schema('saas');
